import { TabObject } from '@packages/tabs/lib/TabContainer';
import { Record } from 'immutable';

export interface TabStateType {
    index: number;
    url: string | null;
    urlProps: { [key: string]: any };
    tabs: TabObject[];
    showTabs: (tab: TabObject) => boolean;
    tabChips: any;
    tabChipsStyle?: string;
}

export const TabState = Record<TabStateType>({
    index: 0,
    url: null,
    urlProps: {},
    tabs: [],
    showTabs() {
        return true;
    },
    tabChips: {},
    tabChipsStyle: '',
});
